import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProdutoAnexoOnline } from '../interfaces/produto-anexo-online';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProdutoAnexoOnlineService {

  readonly path = '/produto/anexo';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}


  getProdutoAnexo(id: number, generatePresignedUrl = false){
    return this.http.get<ProdutoAnexoOnline>(`${this.jwtAuthService.apiUrl+ this.path}/${id}?generatePresignedUrl=${generatePresignedUrl}`); 
  }
  
  getProdutoAnexoOnlinePage(produtoId: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<ProdutoAnexoOnline>> {
    return this.http.get<PageResult<ProdutoAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?page=${page}&size=${size}&produtoId=${produtoId}&order=${order}&direction=${direction}`);
  }

  getProdutoAnexoOnlinePageSearch(search:string, produtoId: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<ProdutoAnexoOnline>> {
    return this.http.get<PageResult<ProdutoAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?search=${search}&page=${page}&size=${size}&produtoId=${produtoId}&order=${order}&direction=${direction}`);
  }

  downloadAnexo(anexoId: number ): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/download/${anexoId}`
    , {responseType: 'arraybuffer'});
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}

